/**
 * UI-6b Task 6 — SlaGauge config editor.
 *
 * Admin types a queue UUID + optional target percent. Phase 2 may swap the
 * text input for a Dropdown loaded from /queues; for Phase 1 we keep the
 * editor minimal so the widget composer ships without a queue-listing
 * round-trip.
 */
import type { JSX } from 'react'
import { InputText } from 'primereact/inputtext'
import { InputNumber } from 'primereact/inputnumber'
import type { SlaGaugeConfig } from './Renderer.js'

interface Props {
  config: SlaGaugeConfig
  onChange: (next: SlaGaugeConfig) => void
}

export function SlaGaugeConfigEditor({ config, onChange }: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-3" data-testid="sla-gauge-config-editor">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Queue ID</span>
        <InputText
          value={config.queueId}
          onChange={(e): void =>
            onChange({ ...config, queueId: e.target.value })
          }
          placeholder="leave empty for all queues"
          aria-label="Queue ID"
        />
      </label>
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Target %</span>
        <InputNumber
          value={config.targetPercent ?? 90}
          onValueChange={(e): void =>
            onChange({ ...config, targetPercent: e.value ?? 90 })
          }
          min={0}
          max={100}
          aria-label="Target percent"
        />
      </label>
    </div>
  )
}
